var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2825_1529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8163 7.66795C19.3426 10.1942 19.3426 14.2901 16.8163 16.8164C14.29 19.3427 10.1941 19.3427 7.66783 16.8164C5.14155 14.2901 5.14155 10.1942 7.66783 7.66795C10.1941 5.14166 14.29 5.14166 16.8163 7.66795ZM19.4033 17.1082C21.6982 13.739 21.3514 9.10945 18.3631 6.12115C14.9826 2.74059 9.50159 2.74059 6.12104 6.12115C2.74048 9.50171 2.74048 14.9827 6.12104 18.3632C9.10929 21.3515 13.7388 21.6983 17.1079 19.4036L21.4235 23.7192C22.0574 24.353 23.0851 24.353 23.7189 23.7192C24.3528 23.0853 24.3528 22.0576 23.7189 21.4238L19.4033 17.1082Z",
    fill: "#27282C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1252 8.75C13.1252 8.26675 12.7334 7.875 12.2502 7.875C11.7669 7.875 11.3752 8.26675 11.3752 8.75V11.375H8.75C8.26675 11.375 7.875 11.7668 7.875 12.25C7.875 12.7333 8.26675 13.125 8.75 13.125H11.3752V15.75C11.3752 16.2332 11.7669 16.625 12.2502 16.625C12.7334 16.625 13.1252 16.2332 13.1252 15.75V13.125H15.75C16.2332 13.125 16.625 12.7333 16.625 12.25C16.625 11.7668 16.2332 11.375 15.75 11.375H13.1252V8.75Z",
    fill: "#27282C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2825_1529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.9d2992971c11bbc39eaf190bfb9e392d.svg";
export { ForwardRef as ReactComponent };